// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  //API_URI: 'http://localhost:3000',
  API_URI: 'https://medioshoteleros.co',
  AWS_ACCESS_KEY: 'AKIAYLKWVS32AZEQ6P6M',//'AKIAYLKWVS32NLTHZEUX',
  AWS_SECRET_KEY: '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',//'N5MLtjSjGLvdKuoz8fnrR5SrEp5pVEynv8ftytgf'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
